var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-floater"},[_c('h3',[_vm._v("Loading...")]),_c('img',{attrs:{"src":require("../../content/images/favicon.svg"),"id":"logo","alt":"smartyfile"}})])
}]

export { render, staticRenderFns }